import { Badge, HoverCard, Text } from '@mantine/core';

interface ColumnBadgeProps {
  label?: string;
}

export const ColumnBadge = ({ label }: ColumnBadgeProps) => {
  return (
    <HoverCard shadow={'md'}>
      <HoverCard.Target>
        <Badge maw={155} variant={'filled'} color={'blue'}>
          <Text fw={700} fz={11} lineClamp={1}>
            {label}
          </Text>
        </Badge>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Text size={'sm'}>{label}</Text>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
